import cls from "./modal.module.scss";
import { Dialog, DialogProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseFillIcon from "remixicon-react/CloseFillIcon";

const Wrapper = styled(Dialog)(() => ({
  "& .MuiBackdrop-root": {
    backgroundColor: "rgba(0, 0, 0, 0.15)",
  },
  "& .MuiPaper-root": {
    backgroundColor: "var(--secondary-bg)",
    boxShadow: "var(--popover-box-shadow)",
    borderRadius: "25px",
    maxWidth: "100%",
  },
  "& .MuiPaper-root.MuiDialog-paperFullScreen": {
    borderRadius: 0,
  },
}));

interface Props extends DialogProps {
  closable?: boolean;
  position?: "right" | "left" | "center";
  disableFocusManagement?: boolean;
}

export default function ModalContainer({
  open,
  onClose,
  children,
  fullScreen,
  closable = true,
  position = "center",
  PaperProps,
  disableFocusManagement = false,
}: Props) {
  return (
    <Wrapper
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      className={cls[position]}
      PaperProps={PaperProps}
      aria-labelledby="address-modal-title"
      disableAutoFocus={disableFocusManagement}
      disableEnforceFocus={disableFocusManagement}
      disableRestoreFocus={disableFocusManagement}
    >
      {closable && (
        <button
          type="button"
          aria-label="Close Modal"
          className={cls.closeBtn}
          onClick={() => {
            if (onClose) onClose({}, "backdropClick");
          }}
        >
          <CloseFillIcon />
        </button>
      )}
      {children}
    </Wrapper>
  );
}
